var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Observable } from 'rxjs';
import { CoralResponse, JsonParsingException } from '../client';
const fetchThis = typeof globalThis !== 'undefined'
    ? globalThis
    : typeof global !== 'undefined'
        ? global
        : window;
/**
 * Handle Coral requests using the Fetch API, producing an Observable of the
 * response.
 *
 * When the Observable is unsubscribed, the request will be aborted (if
 * it hasn't already completed).
 *
 * The handler is constructed with a fetch implementation where the default is
 * the global *fetch* implementation. Clients may choose to provide their own
 * implementation (eg. SentryFetch, node-fetch), if required.
 * This handler would just handle the json responses in body. In case of empty
 * body or non valid json body, it would throw error.
 */
export class CoralFetchHandler {
    constructor(fetchImpl = fetch.bind(fetchThis)) {
        this.fetchImpl = fetchImpl;
    }
    handle(request) {
        return new Observable(observer => {
            const controller = new AbortController;
            // Convert body to JSON string
            const body = (!request.body || typeof request.body === 'string') ? request.body : JSON.stringify(request.body);
            const abortableRequest = request.clone({ body, signal: controller.signal });
            this.fetchImpl(abortableRequest.toNativeRequest())
                .then((response) => __awaiter(this, void 0, void 0, function* () {
                const responseText = yield response.text();
                const responseBody = responseText.length ? parseJsonOrThrow(responseText) : undefined;
                const headers = Array.from(response.headers.entries());
                return new CoralResponse({ headers,
                    body: responseBody,
                    status: response.status,
                    ok: response.ok,
                    url: response.url,
                    statusText: response.statusText });
            }))
                .then(observer.next.bind(observer))
                .catch(observer.error.bind(observer))
                .finally(observer.complete.bind(observer));
            // Return a function to be called when the Observable is unsubscribed.
            return () => controller.abort();
        });
    }
}
/**
 * Helper function that parses JSON and returns the parsed object.
 * If it fails, the function throws a custom exception capturing the exact input (for debugging purposes).
 * @param input - a string of JSON to parse
 */
function parseJsonOrThrow(input) {
    try {
        return JSON.parse(input);
    }
    catch (e) {
        throw new JsonParsingException(input, e);
    }
}
